module.exports = __webpack_public_path__ + "img/u9.88953a8e.svg";